import { render } from "./DuelsStats.vue?vue&type=template&id=ad258252&scoped=true"
import script from "./DuelsStats.vue?vue&type=script&lang=js"
export * from "./DuelsStats.vue?vue&type=script&lang=js"

import "./DuelsStats.vue?vue&type=style&index=0&id=ad258252&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad258252"]])

export default __exports__